import { MenuItem, Menu, Stack, Button } from "@mui/material";
import { useState } from "react";
import { styled, alpha } from "@mui/material/styles";
import ForOthers from "./ForOthers";
import ForStaff from "./ForStaff";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "left",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "left",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    minWidth: 140,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

const GenerateLinks = ({ eventData, setStatus, setAffiliationData }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [staff, setForStaff] = useState(false);
  const [others, setOthers] = useState(false);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <Stack>
        <Button
          id="demo-customized-button"
          aria-controls={open ? "demo-customized-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
        >
          Generate Links
        </Button>

        <StyledMenu
          id="demo-customized-menu"
          MenuListProps={{
            "aria-labelledby": "demo-customized-button",
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
        >
          <MenuItem
            disableRipple
            onClick={() => {
              setForStaff(true);
              handleClose();
            }}
          >
            For Staff
          </MenuItem>
          <MenuItem
            disableRipple
            onClick={() => {
              setOthers(true);
              handleClose();
            }}
          >
            For Others
          </MenuItem>
        </StyledMenu>
      </Stack>
      {staff && (
        <ForStaff
          open={staff}
          onClose={() => setForStaff(false)}
          eventData={eventData}
          setAffiliationData={setAffiliationData}
          setStatus={setStatus}
        />
      )}
      {others && (
        <ForOthers
          open={others}
          onClose={() => setOthers(false)}
          eventData={eventData}
          setStatus={setStatus}
          setAffiliationData={setAffiliationData}
        />
      )}
    </>
  );
};

export default GenerateLinks;
